import { observable, action, toJS } from 'mobx';
import {toast} from "react-toastify";

class ObjectListStore {
  DEFAULT = {
    baseUrl: "",
    fields: [""],
    headers: [],
    filters: {
      page: 1,
      size: 25,
      order_by: "id",
      desc: true
    },
    result: {
      count: 0,
      items: [],
      total_pages: 0
    },
    listField: "items",
    idField: "id"
  };

  constructor(api) {
    this.api = api;
  }

  @action setType(type) {
    if (this[type]) {
      this.type = type;
      this.setData(this[type]);
    }
  }

  @action reset() {
    console.log('reseting...', this.type, this[this.type]);
    if (this.type) {
      this.setType(this.type);
    } else {
      this.setData(this.DEFAULT);
    }
  }

  @action setData(data) {
    if (data) {
      if (data.fields) {
        this.fields = data.fields;
      }

      if (data.headers) {
        this.headers = data.headers;
      }

      if (data.filters) {
        this.filters = data.filters;
      }

      if (data.result) {
        this.result = data.result;
      }

      if (data.baseUrl) {
        this.baseUrl = data.baseUrl;
      }

      if (data.listField) {
        this.listField = data.listField;
      }

      if (data.idField) {
        this.idField = data.idField;
      }

      if (data.processResult) {
        this.processResult = data.processResult;
      }
    }
  }

  baseUrl;
  processResult;
  type;
  @observable fields;
  @observable filters = this.DEFAULT.filters;
  @observable selectedItems = [];
  @observable result = {
    count: 0
  };

  @observable listField = 'items';

  @observable searching = false;

  setBaseUrl = (baseUrl) => {
    this.baseUrl = baseUrl;
  };

  getStore(type) {
    return type ? this[type] : this;
  }

  @action
  selectItem = (item) => (e) => {
    this.selectedItems.push(item[this.idField]);
  };

  @action
  setFilter = (name, value) => {
    this.filters[name] = value;
  };

  @action
  setFilters = (data) => {
    const newFilters = Object.assign({}, this.filters, data);
    this.filters = newFilters;
  };

  @action removeFilter = (name) => {
    if (this.filters[name]) {
      delete this.filters[name];
    }
  };

  @action setPage = (page) => {
    this.filters[page] = page;
  };

  @action setSize = (size) => {
    this.filters[size] = size;
  };

  @action
  toggleOrder = (field) => (e) => {
    if (this.filters.order_by === field) {
      this.filters.desc = !this.filters.desc;
    } else {
      this.filters.order_by = field;
      this.filters.desc = true;
    }

    this.search();
  };

  @action
  toggleStaticOrder = (field) => (e) => {
    if (this.filters.order_by === field) {
      this.filters.desc = !this.filters.desc;
    } else {
      this.filters.order_by = field;
      this.filters.desc = true;
    }

    if (this.filters.desc) {
      this.result.items = this.result.items.slice().sort((a,b) => (a[this.filters.order_by] > b[this.filters.order_by]) ? 1 : ((b[this.filters.order_by] > a[this.filters.order_by]) ? -1 : 0));
    } else {
      this.result.items = this.result.items.slice().sort((b,a) => (a[this.filters.order_by] > b[this.filters.order_by]) ? 1 : ((b[this.filters.order_by] > a[this.filters.order_by]) ? -1 : 0));
    }
  };

  @action
  search = () => {
    this.searching = true;
    this.selectedItems = [];
    const filters = toJS(this.filters);

    if (filters.page && filters.page > 0) {
      filters.page = filters.page - 1;
    }

    this.api.get(this.baseUrl, filters)
      .then(response => {
        this.searching = false;
        if (response.status === 200) {
          if (this.processResult) {
            this.processResult(response.data, this);
          }
          else {
            if (Array.isArray(response.data)) {
              this.result = {
                items: response.data,
                count: response.data.length,
                total_pages: 1
              }
            } else {
              let result = {
                items: response.data[this.listField],
                count: response.data.count ? response.data.count : response.data[this.listField].length,
                total_pages: response.data.count && this.filters.size ? Math.ceil(response.data.count / this.filters.size) : 1
              }

              this.result = Object.assign(response.data, result);
            }
          }
        }else{
          if (response?.data?.errors) {
            toast.error(response.data.errors[0]);
          } else {
            toast.error('Unable to fetch data.');
          }
        }
      })
  };

  @action directAddItems(items) {
    if (!this.result) {
      this.result = {
        items: items,
        count: items.length,
        total_pages: 1
      }
    } else {
      const newItems = this.result.items.slice().concat(items);
      this.result = {
        items: newItems,
        count: newItems.length,
        total_pages: this.result.total_pages ? this.result.total_pages : 1
      }
    }
  }

  @action directRemoveItem(item) {
    if (this.result) {
      const items = this.result.items.slice().filter(i => i[this.idField] !== item[this.idField]);
      this.result = {
        items: items,
        count: items.length,
        total_pages: this.result.total_pages ? this.result.total_pages : 1
      }
    }
  }

  isSelected = (item) => {
    return this.selectedItems.includes(item[this.idField]);
  }
}

export default ObjectListStore;
